(function( $ ) {
    $.fn.uploadFile = function () {
        var token = $('meta[name="csrf-token"]').attr('content');
        var $el = $(this);
        var url = $el.attr('data-url');
        var id = $el.attr('data-id');
        var callback = $el.attr('data-callback');
        var callbackerror = $el.attr('data-callbackerror');
        new ss.SimpleUpload({
            button: $el.get(0),
            url: url,
            allowedExtensions: ['jpg','jpeg','gif','png','pdf','doc','docx','xls','xlsx'],
            name: 'file',
            multipart: true,
            maxSize:10290,
            data:{'_token':token},
            responseType: 'json',
            onSubmit: function(){
                MessageBox.loading('open');
            },
            onComplete: function( filename, response )
            {
                MessageBox.loading('hide');
                $('#'+id+'_form').append("<input class='my-hidden-upload-file' type='hidden' id='"+id+"_originalname' name='"+id+"_originalname' value='"+response.originalname+"'>")
                    .append("<input class='my-hidden-upload-file' type='hidden' id='"+id+"_id' name='"+id+"_id' value='"+response.id+"'>");
                $('#'+id+'_btn').hide();
                $('#'+id+'_div').removeClass('hidden');
                $('#'+id+'_link').attr('href',response.url).text(response.originalname)
                    .attr('href',response.url).text(response.originalname);
                if(typeof callback_upload_file==='function')
                {
                    callback_upload_file(response);
                }
            },
            onExtError:function()
            {
                MessageBox.error('ขออภัย ไฟล์ที่ท่านเลือกไม่ได้รับอนุญาตให้อัพโหลดค่ะ <br/>ไฟล์ที่อนุญาตคือ <strong>jpg jpeg gif png pdf doc docx xls xlsx</strong> เท่านั้นค่ะ');
            },
            onSizeError:function()
            {
                MessageBox.error('ขออภัย ไฟล์ที่ท่านเลือกมีน้ำหนักเกินขนาดที่กำหนดค่ะ <br/>ขนาดที่กำหนดคือ <strong>10 MB</strong> เท่านั้นค่ะ');
            },
            onError: function( filename, errorType, status, statusText, response, uploadBtn, fileSize)
            {
                MessageBox.loading('hide');
                var obj = jQuery.parseJSON(response);
                if(typeof obj==='object')
                {
                    MessageBox.error(obj[0]);
                }
            }
        });
    }
}( jQuery ));

(function( $ ) {
    $.fn.uploadImgFile = function () {
        var token = $('meta[name="csrf-token"]').attr('content');
        var $el = $(this);
        var url = $el.attr('data-url');
        var id = $el.attr('data-id');
        var callback = $el.attr('data-callback');
        var callbackerror = $el.attr('data-callbackerror');
        new ss.SimpleUpload({
            button: $el.get(0),
            url: url,
            allowedExtensions: ['jpg','jpeg','gif','png'],
            name: 'file',
            multipart: true,
            maxSize:10290,
            data:{'_token':token,'is_img':1},
            responseType: 'json',
            onSubmit: function(){
                MessageBox.loading('open');
            },
            onComplete: function( filename, response )
            {
                MessageBox.loading('hide');
                $('#'+id+'_form').append("<input class='my-hidden-upload-file' type='hidden'  name='"+id+"_originalname' value='"+response.originalname+"'>")
                    .append("<input class='my-hidden-upload-file' type='hidden' name='"+id+"_id' value='"+response.id+"'>");
                $('#'+id+'_btn').hide();
                $('#'+id+'_div').removeClass('hidden');
                $('#'+id+'_link').attr('href',response.url).text(response.originalname)
                    .attr('href',response.url).text(response.originalname);
                if(typeof callback_upload_file==='function')
                {
                    callback_upload_file(response);
                }
            },
            onExtError:function()
            {
                MessageBox.error('ขออภัย ไฟล์ที่ท่านเลือกไม่ได้รับอนุญาตให้อัพโหลดค่ะ <br/>ไฟล์ที่อนุญาตคือ <strong>jpg jpeg gif png </strong> เท่านั้นค่ะ');
            },
            onSizeError:function()
            {
                MessageBox.error('ขออภัย ไฟล์ที่ท่านเลือกมีน้ำหนักเกินขนาดที่กำหนดค่ะ <br/>ขนาดที่กำหนดคือ <strong>10 MB</strong> เท่านั้นค่ะ');
            },
            onError: function( filename, errorType, status, statusText, response, uploadBtn, fileSize)
            {
                MessageBox.loading('hide');
                var obj = jQuery.parseJSON(response);
                if(typeof obj==='object')
                {
                    MessageBox.error(obj[0]);
                }
            }
        });
    }
}( jQuery ));

(function( $ ) {
    $.fn.customUploadFile = function (collback_success) {
        var token = $('meta[name="csrf-token"]').attr('content');
        var $el = $(this);
        var url = $el.attr('data-url');
        var callback = $el.attr('data-callback');
        var _collback_success = collback_success;
        $el.removeClass('xupload');
        new ss.SimpleUpload({
            button: $el.get(0),
            url: url,
            allowedExtensions: ['jpg','jpeg','gif','png','pdf','doc','docx','xls','xlsx'],
            name: 'file',
            maxSize:10290,
            multipart: true,
            data:{'_token':token},
            responseType: 'json',
            onSubmit: function(){
                MessageBox.loading('open');
            },
            onComplete: function( filename, response )
            {
                MessageBox.loading('hide');
                if(typeof custom_callback_upload_file==='function')
                {
                    custom_callback_upload_file(response);
                }
                else if(typeof _collback_success=='function')
                {
                    _collback_success(response,$el);
                }
            },
            onExtError:function()
            {
                MessageBox.error('ขออภัย ไฟล์ที่ท่านเลือกไม่ได้รับอนุญาตให้อัพโหลดค่ะ <br/>ไฟล์ที่อนุญาตคือ <strong>jpg jpeg gif png pdf doc docx xls xlsx</strong> เท่านั้นค่ะ');
            },
            onSizeError:function()
            {
                MessageBox.error('ขออภัย ไฟล์ที่ท่านเลือกมีน้ำหนักเกินขนาดที่กำหนดค่ะ <br/>ขนาดที่กำหนดคือ <strong>10 MB</strong> เท่านั้นค่ะ');
            },
            onError: function( filename, errorType, status, statusText, response, uploadBtn, fileSize)
            {
                MessageBox.loading('hide');
                var obj = jQuery.parseJSON(response);
                if(typeof obj==='object')
                {
                    MessageBox.error(obj[0]);
                }
            }
        });
    }
}( jQuery ));

$('.uploadfile-btn').each(function(i,e){$(e).uploadFile();});
$('.uploadfile-img-btn').each(function(i,e){$(e).uploadImgFile();});

$(document).on('click','.remove-file-upload',function(e){
    e.preventDefault();
    var id = $(this).attr('data-id');
    console.log(id+2);

    $('#'+id+'_div').addClass('hidden');
    $('#'+id+'_btn').show();
    $('#'+id+'_originalname').remove();
    $('#'+id+'_id').remove();
});
$(document).on('click','.btn-remove-upload-file',function(e){
    e.preventDefault();
    var id = $(this).attr('data-id');
    $('#old_file_'+id).remove();
    $('#'+id+'_existing').remove();
    $('#'+id+'_form').removeClass('hidden');
});